import{s as g}from"./chunk-UUPWCWDG.js";import{c as e}from"./chunk-K6WIZ6YP.js";import{a as o,d as r}from"./chunk-QYQWCYOC.js";import{m as t}from"./chunk-HBP5N4FR.js";t();g();r();function s(){return e(o.getState())}export{s as a};
//# sourceMappingURL=chunk-WDAOWAN7.js.map
